import { render, staticRenderFns } from "./XmlTools.vue?vue&type=template&id=36ec1e68&scoped=true"
import script from "./XmlTools.vue?vue&type=script&lang=js"
export * from "./XmlTools.vue?vue&type=script&lang=js"
import style0 from "./XmlTools.vue?vue&type=style&index=0&id=36ec1e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec1e68",
  null
  
)

export default component.exports